
import { defineComponent, ref, computed, getCurrentInstance, nextTick } from "vue-demi";
import axios from "@/plugins/http";
import { API_ROUTES } from "@/utils/API";
import { API_TDependant } from "@/models/dependant";

export default defineComponent({
  name: "SWDependantVisaPopup",

  emits: ["ok", "cancel"],

  props: {
    dependantsList: { type: Array as () => API_TDependant[], default: () => [] },
  },

  setup(props, { emit }) {
    const instance = getCurrentInstance()?.proxy;
    const router = instance?.$router;

    const isPopoverOpen = ref(true);

    const onCancel = () => {
      isPopoverOpen.value = false;

      emit("cancel");
    };

    const loading = ref(false);
    const selectedDependant = ref(null);

    const startButtonDisabled = computed(() => selectedDependant.value === null || loading.value);

    function updateStartedDependant() {
      const index = props.dependantsList.findIndex((d) => d.id === selectedDependant.value.id);

      if (index >= 0) {
        Object.assign(props.dependantsList[index], { case_created: true });
      }

      selectedDependant.value = null;
    }

    async function goToCase(item) {
      if (!item?.case_id) return;

      await router.push(`/cases/${item.case_id}`);
    }

    async function onSubmit() {
      if (selectedDependant.value === null) return;

      loading.value = true;

      try {
        const { data } = await axios.post(
          API_ROUTES.START_DEPENDANT_VISA(0, selectedDependant.value.id)
        );

        if (!data) return;

        updateStartedDependant();

        await nextTick();

        emit("ok");

        await nextTick();

        await goToCase(data);
      } finally {
        loading.value = false;
      }
    }

    function generateSelectOption(payload) {
      const { first_name, last_name } = payload;
      const name = `${first_name} ${last_name}`;

      return name;
    }

    const options = computed(() =>
      props.dependantsList.map((cur) => ({
        label: generateSelectOption(cur),
        value: cur,
        disabled: cur.case_created,
        badge: cur.case_created ? "In Progress" : "",
      }))
    );

    const selectedDependantDisable = computed(() => options.value.length === 0);

    const dependantSelectProps = computed(() => ({
      options: options.value,
      disabled: selectedDependantDisable.value,
      placeholder: selectedDependantDisable.value ? "noAvailableDependant" : "placeholder",
    }));

    return {
      isPopoverOpen,
      onSubmit,
      onCancel,
      startButtonDisabled,
      loading,
      selectedDependant,
      dependantSelectProps,
    };
  },
});
